import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import NavItem from './NavItem'
import classNames from './styles.module.scss'


NavItemWrapper.propTypes = {
  isActiveCart: PropTypes.bool,
  renderAs: PropTypes.oneOf(['li', 'div']),
}

export default function NavItemWrapper({
  isActiveCart = false,
  renderAs = 'li',
  ...props
}) {
  const [ activeCards, setActiveCards ] = useState({})
  const handleActiveCard = useCallback(id => {
    setActiveCards({ ...activeCards, [id]: !activeCards[id] })
  }, [activeCards, setActiveCards])
  useEffect(() => {
    if(!isActiveCart) {
      setActiveCards({})
    }
  }, [isActiveCart])
  const Wrapper = renderAs === 'div' ? 'div' : 'li'
  return (
    <Wrapper className={classNames.navWrapper}>
      <NavItem
        activeCards={activeCards}
        setActiveCards={setActiveCards}
        isActiveCart={isActiveCart}
        handleActiveCard={handleActiveCard}
        isFirstLevel
        {...props}
      />
    </Wrapper>
  )
}
